import React from "react";
import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

export const TopMarquee = () => (
    <div
        data-testid="top-marquee"
        className="bg-black text-[#CCFF00] border-b-2 border-black py-2"
    >
        <Marquee speed={50} gradient={false}>
            {Array.from({ length: 8 }).map((_, i) => (
                <span
                    key={`marquee-slug-${i}`}
                    className="font-mono text-xs font-bold uppercase tracking-widest mx-6 inline-flex items-center gap-3"
                >
                    FITS ME
                    <Asterisk className="w-3 h-3" />
                    ONE SEARCH · EVERY STORE
                    <Asterisk className="w-3 h-3" />
                    YOUR SIZE ONLY
                    <Asterisk className="w-3 h-3" />
                    AI TRY-ON BEFORE YOU BUY
                    <Asterisk className="w-3 h-3" />
                </span>
            ))}
        </Marquee>
    </div>
);
